var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafeStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.999 443.371V362.877L91 264.67V338.999C91 346.911 95.1253 354.201 101.777 358.044L245.824 441.258C247.472 442.21 249.214 442.915 250.999 443.371C254.283 444.21 257.716 444.21 260.999 443.371Z",
    fill: "url(#paint0_linear_3587_1059)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.001 69.6291L251.001 150.123L421 248.33L421 174.001C421 166.089 416.875 158.799 410.223 154.956L266.176 71.7418C264.528 70.7895 262.786 70.0853 261.001 69.6291C257.717 68.7904 254.284 68.7904 251.001 69.6291Z",
    fill: "url(#paint1_linear_3587_1059)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.999 362.877V443.371C262.785 442.915 264.526 442.21 266.175 441.258L330.555 404.067C333.924 402.12 335.999 398.525 335.999 394.634V320.981L260.999 362.877Z",
    fill: "#2E9A99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.999 320.981C335.999 313.069 331.874 305.779 325.222 301.936L248.527 344.778L251.841 346.693C257.494 349.958 260.999 356.153 260.999 362.877L335.999 320.981Z",
    fill: "url(#paint2_linear_3587_1059)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.222 301.936L176.777 216.181L100.082 259.023L248.527 344.778L325.222 301.936Z",
    fill: "url(#paint3_linear_3587_1059)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.777 216.181C170.131 212.342 166.007 205.061 166 197.157L91 239.053V247.489C91 251.38 93.0752 254.976 96.4444 256.922L100.082 259.023L176.777 216.181Z",
    fill: "url(#paint4_linear_3587_1059)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166 117.856L101.777 154.956C95.1253 158.799 91 166.089 91 174.002V239.053L166 197.157L166 197.136V117.856Z",
    fill: "url(#paint5_linear_3587_1059)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M251.001 150.123L251.001 69.6291C249.215 70.0853 247.474 70.7895 245.825 71.7418L181.445 108.933C178.076 110.88 176.001 114.475 176.001 118.366L176.001 192.019L251.001 150.123Z",
    fill: "url(#paint6_linear_3587_1059)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.001 192.019C176.001 199.931 180.126 207.221 186.778 211.064L263.473 168.222L260.159 166.307C254.506 163.042 251.001 156.847 251.001 150.123L176.001 192.019Z",
    fill: "url(#paint7_linear_3587_1059)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M186.778 211.064L335.223 296.819L411.918 253.977L263.473 168.222L186.778 211.064Z",
    fill: "url(#paint8_linear_3587_1059)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M335.223 296.819C341.869 300.658 345.993 307.939 346 315.843L421 273.947L421 265.511C421 261.62 418.925 258.024 415.556 256.078L411.918 253.977L335.223 296.819Z",
    fill: "url(#paint9_linear_3587_1059)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M346 395.144L410.223 358.044C416.875 354.201 421 346.911 421 338.998L421 273.947L346 315.843L346 315.864L346 395.144Z",
    fill: "#2E9A99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3587_1059",
    x1: 283.237,
    y1: 461.711,
    x2: 32.1294,
    y2: 328.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10719,
    stopColor: "#2E9A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855894,
    stopColor: "#30D3D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3587_1059",
    x1: 228.763,
    y1: 51.289,
    x2: 479.871,
    y2: 184.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10719,
    stopColor: "#3AFACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855894,
    stopColor: "#30D3D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3587_1059",
    x1: 282.975,
    y1: 304.572,
    x2: 299.643,
    y2: 333.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#159190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E9A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3587_1059",
    x1: 206.5,
    y1: 196.999,
    x2: 291.34,
    y2: 333.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45F8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942032,
    stopColor: "#169696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3587_1059",
    x1: 60.0954,
    y1: 132.183,
    x2: 121.608,
    y2: 245.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.448049,
    stopColor: "#139990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972278,
    stopColor: "#3AFACE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3587_1059",
    x1: 83.9286,
    y1: 122.379,
    x2: 146.842,
    y2: 238.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201297,
    stopColor: "#3AFACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FD9BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3587_1059",
    x1: 173.29,
    y1: 64.8828,
    x2: 240.384,
    y2: 193.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354221,
    stopColor: "#3AFACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FD9BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3587_1059",
    x1: 164.044,
    y1: 91.979,
    x2: 220.957,
    y2: 204.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285435,
    stopColor: "#26BBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970867,
    stopColor: "#3AFACE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3587_1059",
    x1: 371.17,
    y1: 293.558,
    x2: 275.496,
    y2: 134.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039935,
    stopColor: "#169696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96419,
    stopColor: "#25FFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3587_1059",
    x1: 372.615,
    y1: 261.723,
    x2: 385.472,
    y2: 283.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B9C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959191,
    stopColor: "#2E9A99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeStep);
export default __webpack_public_path__ + "static/media/SafeStep.4e1561e2584502c2fd8f9111f048486a.svg";
export { ForwardRef as ReactComponent };